import { IconBase, IconComponent } from './BaseIcon';

export const Phone: IconComponent = (props) => (
  <IconBase {...props}>
    <path
      d="M21.4,29.9c-1.1,0-2.2-0.2-3.3-0.7c-7-3-12.5-8.6-15.4-15.6C2,11.8,1.9,9.8,2.5,8c1.8-5.2,5.9-5.9,7.6-5.9
      c0.8,0,1.4,0.5,1.7,1.2l0,0L14,9c0.3,0.7,0.1,1.5-0.4,2l-1.5,1.4l7.3,7.3l1.5-1.5c0.5-0.5,1.3-0.7,2-0.4l5.8,2.4
      c0.7,0.3,1.2,1,1.2,1.8c-0.2,3.2-2.2,6.1-5.2,7.3C23.6,29.7,22.5,29.9,21.4,29.9z M10,4.2c-1.3,0-4.2,0.6-5.6,4.5
      C3.9,10.1,4,11.6,4.5,13c2.7,6.4,7.8,11.6,14.2,14.4c1.6,0.7,3.4,0.7,5.1,0c2.3-0.9,3.8-3,3.9-5.5l-5.6-2.3l-1.5,1.5
      c-0.7,0.7-1.9,0.7-2.6,0l-7.5-7.4c-0.7-0.7-0.7-1.9,0-2.6L12,9.6L10,4.2z M25.9,13.9c-0.8-3.9-3.9-7-7.8-7.8v2.1
      c2.8,0.7,5,2.9,5.8,5.8L25.9,13.9L25.9,13.9z M27.9,13.9h2C29,7.8,24.2,3,18.1,2.1v2C23.1,4.9,27,8.9,27.9,13.9z"
    />
  </IconBase>
);
